<template>
  <div class="vacationban-view has-header">
    <div v-if="loading" class="loading-md bg">
      <i class="fas fa-spinner"></i>
      <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
        {{ loadingText }}
      </div>
    </div>
    <div class="header main">
      <div class="align-left">
        <dateselectionheader
            :label="dateDisplay"
            @PrevDate="SelectPreviousDate"
            @NextDate="SelectNextDate"
            @CalendarOpen="toggleDatePicker"
            @SetToday="SelectToday"/>
      </div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons"/>
      </div>
      <div class="align-right">
      </div>
    </div>


    <div class="scrollbar-container">
      <div class="sub-header" v-if="displayedTimeframeSelected.label === 'M'">
        <div class="title" v-bind:style="{width: GetWidthFirstTitle()}">
          <div class="label ">{{ timeFrameStart.format("MMMM") }}</div>
        </div>

      </div>

      <div class="day-container hours" v-if="displayedTimeframeSelected.label === 'Y'">
        <div class="background"></div>
        <div class="day" v-for="(month, indexD) in monthsDisplayed" :key="indexD"
             v-bind:style="[GetTimeMarkWidth(indexD)]">

          <div class="day-text" v-on:click="SelectMonth(month)">
            <div class="name">{{ $helpers.translateMonth(month.name) }}
            </div>

          </div>

        </div>
      </div>
      <div class="day-container hours" v-if="displayedTimeframeSelected.label === 'M'">
        <div class="background"></div>
        <div class="day" v-for="(day, indexD) in daysDisplayed" :key="indexD" v-bind:style="[GetTimeMarkWidth(indexD)]">

          <div class="day-text">
            <div class="name">{{ $helpers.translateDayShort(day.name) }}
            </div>
            <div class="date">{{ day.date }}
            </div>
          </div>

        </div>
      </div>
      <div class="grid">

        <div class="header">
          <div class="label">{{ $t('pref.main.block') }}</div>
          <!--
         <div class="employee-filter button" v-on:click="OpenFilterPopup($event)">
         <div class="label" style="padding-left: 4px; padding-top: 1px;">
             <i class="fas fa-filter"></i>
         </div>
         </div>
         -->

        </div>

        <div class="backdrop"></div>

        <div class="group" v-for="group in spotGroups" :key="group.id">
          <div class="header"
               v-bind:style="[GetGroupStyles(group)]">

            <div class="label">{{ group.name }}</div>

          </div>

          <div class="row" v-for="(vacationBan) in vacationBansBySpotMap[group.id]" :key="vacationBan.id">
            <div class="vacationban">
              <div class="background"></div>
              <div class="background shadow"></div>

              <div class="name">{{ vacationBan.description }}</div>

              <div style="width: 30px; height: 30px;">
                <div class="fa-stack detail"
                     v-bind:style="{'z-index': 99}" v-on:click="OpenVacationBanButtonMenu($event, vacationBan)">
                  <i style="font-size:25px; right:0px;" class="fas fa-circle fa-stack-2x"></i>
                  <i style="font-size:25px; margin-left:-1px;" class="fas fa-cog fa-stack-2x"></i>
                </div>
              </div>

            </div>

            <div class="timeframe" v-for="(timeFrame) in timeFrameMap[vacationBan.id]" :key="timeFrame.key"
                 v-bind:style="[GetTimeFrameStyles(timeFrame)]"
                 v-bind:id="timeFrame.vacationban.id"
                 v-on:mouseup="SelectTimeFrame($event, timeFrame)"
                 v-tooltip="getVacationBanTooltip(timeFrame)"
                 v-on:mouseenter="CheckLabelLength($event)">
              <div class="handle start" v-if="showTimeFrameHandles" v-on:mousedown="StartDragTimeFrame($event, timeFrame, true)"><div class="inner"></div></div>
              <div class="handle end" v-if="showTimeFrameHandles" v-on:mousedown="StartDragTimeFrame($event, timeFrame, false)"><div class="inner"></div></div>
              <div class="label">{{ timeFrame.label }}</div>
              <div class="shadow"></div>

            </div>
            <div class="top-line"></div>
            <div class="bottom-line"></div>
          </div>
        </div>
        <div class="time-marks" v-bind:class="{monthly: displayedTimeframeSelected.label === 'Y'}">
          <div class="mark" v-for="(mark, indexMark) in timeMarks" v-bind:index="indexMark" :key="indexMark"
               v-bind:style="[GetTimeMarkWidth(indexMark)]" v-bind:class="{'day-split' : mark === '00'}">
          </div>
        </div>
        <div class="time-marks labels" v-if="displayedTimeframeSelected.label === 'D'">
          <div class="mark" v-for="(mark, indexMark) in timeMarks" v-bind:index="indexMark" :key="indexMark"
               v-bind:style="[GetTimeMarkWidth(indexMark)]" v-bind:class="{'day-split' : mark === '00'}">
            <div class="label" v-if="displayedTimeframeSelected.label !== 'M'">
              {{
                displayedTimeframeSelected.label !== 'Y' ? mark : displayedTimeframeSelected.timeStart.clone().month(indexMark).format('MMM')
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'vacationbanoverview',
  components: {},
  data() {
    return {
      vacationBanMap: {},
      displayedTimeframes: [],
      displayedTimeframeSelected: null,
      timeFrameStart: this.$helpers.getMomentUTC().startOf('year'),
      timeFrameEnd: this.$helpers.getMomentUTC().startOf('year').add(1, 'year'),
      timeFrameLength: 365 * 24 * 60 * 60 * 1000,
      currentYear: this.$helpers.getCurrentMonthMomentTZ().year(),
      currentMonth: this.$helpers.getCurrentMonthMomentTZ().startOf('year').month(),
      currentDate: 1,
      error: false,
      loading: true,
      loadingText: null,

      dragging: false,
      draggingTimeFrame: null,
      draggingTime: null,
      draggingStart: false,
      draggingStartPos: {x: 0, y: 0},
      draggingHandle: null,
      draggingGroup: null,
    }
  },
  created: function () {
    if (this.$store.state.jwt !== undefined && this.$store.state.storeId !== undefined) {
      if (this.rosterFromTo != null) {
        let startDate = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, 1, 1);
        this.onDatePicked(startDate, 'Y', 24);
      } else {
        this.onDatePicked(this.$helpers.getCurrentMonthMomentTZ(), 'Y', 24);
      }
    }
  },
  mounted: function () {
    this.refresh();
  },
  computed: {
    ...mapGetters(['storeId', 'rosterFromTo', 'spotMap']),
    showTimeFrameHandles() {
      return this.displayedTimeframeSelected.label === 'M';
    },
    dateDisplay: function () {
      if (this.timeFrameStart != null) {
        if (this.displayedTimeframeSelected.label === 'D') return this.timeFrameStart.format('DD.MM.YYYY');
        if (this.displayedTimeframeSelected.label === 'M') return this.timeFrameStart.format('MMM YYYY');
        if (this.displayedTimeframeSelected.label === 'Y') return this.timeFrameStart.format('YYYY');
        return '-';
      } else {
        return '-';
      }

    },
    daysDisplayed() {
      let days = [];
      let date = this.$helpers.getMomentTZ().date(this.currentDate).month(this.currentMonth).year(this.currentYear).minutes(0).seconds(0).milliseconds(0);
      for (let x = 0; x < date.daysInMonth(); x++) {
        date.date(x + 1);
        days.push({
          name: date.format('dddd').substring(0, 2),
          date: date.format('DD').substring(0, 2) + '.' + date.format('MM').substring(0, 2),
          moment: date.clone(),
        });
      }
      return days;

    },
    monthsDisplayed() {
      let days = [];
      let date = this.$helpers.getMomentTZ().date(1).month(0).year(this.currentYear).minutes(0).seconds(0).milliseconds(0);
      for (let x = 0; x < 12; x++) {

        days.push({
          name: date.format('MMMM'),

          moment: date.clone(),
        });
        date.add(1, 'months');
      }
      return days;

    },
    timeMarks() {

      let marks = [];

      let timeFrame = this.displayedTimeframeSelected;
      for (let x = 0; x < timeFrame.divisions; x++) {
        let timemark = (x + 1 > 9 ? x + 1 : '0' + (x + 1));

        if (timeFrame.length <= 48 * 60 * 60 * 1000) timemark = ((x % 24) > 9 ? (x % 24) : '0' + (x % 24));

        marks.push(timemark.toString());
      }
      return marks;
    },
    headerButtons() {

      let view = this;

      let state = {
        buttons: []
      };
      //BUTTON 1
      if (this.displayedTimeframeSelected.label != 'Y') {
        state.buttons.push({
          type: "block border-r",
          icon: "fa-chevron-left",
          click: () => {
            view.onDatePicked(view.timeFrameStart.clone().startOf('year'), 'Y', 24);
          },
          tooltip: this.$t('shift.groups.backToYear')
        });
      }
      state.buttons.push({
        type: "block",
        icon: "fa-sync-alt",
        click: () => {
          view.refresh(true);
        },
        tooltip: this.$t('global.general.refreshData')
      });
      state.buttons.push({
        type: "block green",
        icon: "fa-plus",
        click: ($event) => {
          view.OpenCreateVacationBanModal($event);
        },
        tooltip: this.$t('pref.main.createAbsenceBlock'),
        helperText: this.$t('pref.main.createAbsenceBlockHelp'),
        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2523856897"
      });
      state.helperLinks = [
      {
        icon: "fa-video",
          title: this.$t('store.structure.watchTrainingVideo'),
          helperText: this.$t('store.structure.watchTrainingVideoHelp'),
          externalUrl: "https://www.youtube.com/watch_popup?v=dBXnotWZvwo",
          externalLabel: this.$t('pref.main.trainingVideoAbsence'),
          cancelLabel: this.$t('global.ui.close'),
        },
        {
          title:  this.$t('store.structure.getSupport'),
          helperText:  this.$t('store.structure.getSupportHelp'),
          externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
          externalLabel:  this.$t('store.structure.getSupportLabel'),
          cancelLabel: this.$t('global.ui.close'),
        }
      ];
      return state;
    },
    spotGroups() {
      let result = [{id: "default", name: this.$t('pref.main.allSpots'), priority: 0}];
      Object.values(this.spotMap).forEach(spot => {
        Object.values(this.vacationBanMap).forEach(ban => {
          if (ban.spotId === spot.id) {
            if (result.indexOf(spot) === -1) {
              result.push(spot);
            }
          }
        })
      })
      result.sort((a, b) => {
        let order = a.priority - b.priority;
        if (order == 0) {
          return a.name.localeCompare(b.name);
        } else {
          return order;
        }
      })
      return result;
    },
    spotDropDownItems() {
      let items = Object.values(this.spotMap).sort((a, b) => {
        return a.name.localeCompare(b.name);
      }).map(pg => {
        return {value: pg.id, label: pg.name}
      });
      items.unshift({value: null, label: this.$t('pref.main.allSpots')});
      return items;
    },
    vacationBansBySpotMap() {
      let view = this;
      let map = {
        "default": [],
      }
      Object.values(this.spotMap).forEach(spot => {
        map[spot.id] = [];
      })
      Object.values(this.vacationBanMap).filter(ban => {
        let from = view.$helpers.getMomentFromStringTZ(ban.from);
        let to = view.$helpers.getMomentFromStringTZ(ban.to);
        return (from < view.timeFrameEnd && to > view.timeFrameStart)
      }).sort((a, b) => {
        let aFrom = view.$helpers.getMomentFromStringTZ(a.from);
        let bFrom = view.$helpers.getMomentFromStringTZ(b.from);

        return aFrom - bFrom;
      }).forEach(ban => {
        if (map[ban.spotId]) {
          map[ban.spotId].push(ban);
        } else {
          map.default.push(ban);
        }
      });
      return map;
    },
    timeFrameMap() {
      let view = this;
      let map = {};
      Object.values(this.vacationBanMap).forEach(ban => {
        if (!map[ban.id]) {
          map[ban.id] = [];
        }
        let pfrom = view.$helpers.getMomentFromStringTZ(ban.from);
        let pto = view.$helpers.getMomentFromStringTZ(ban.to);
        map[ban.id].push({key: "tf-" + ban.id, vacationban: ban, fromDate: pfrom, toDate: pto, active: ban.active, type: ban.type});
      })
      return map;
    }
  },
  watch: {
    storeId: function (val, oldVal) {
      this.refresh(true);
    },
    rosterFromTo(newVal, oldVal) {
      if (newVal != null && this.$store.state.jwt != undefined && this.$store.state.storeId != undefined) {
        this.refresh();
      }
    },
  },
  // methods that implement data logic.
  methods: {
    refresh: function (force = false) {
      let view = this;
      this.loading = true;
      view.loadVacationBans()
          .then(map => {
            return view.$helpers.GetSpotMap(force);
          })
          .then(response => {
            view.loading = false;
          })
          .catch(function (error) {
            view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
            view.loading = false;
            console.log(error)
          });
    },

    OpenVacationBanButtonMenu($event, project) {
      let view = this;
      view.$helpers.OpenButtonContainer([
        {
          color: '', icon: 'fa-info', label: this.$t('shift.plan.info'), click: () => {
            view.OpenVacationBanInfo($event, project)
          }
        },
        {
          color: '#e5c420', icon: 'fa-edit', label: this.$t('global.ui.edit'), click: () => {
            view.OpenEditVacationBanModal($event, project)
          }
        },
        {
          color: '#e51650', icon: 'fa-trash', label: this.$t('global.ui.delete'), click: () => {
            view.OpenDeleteVacationBanModal($event, project)
          }
        },

      ], {elRelative: $event.currentTarget, offsetx: 5, offsety: -10, closeOnSelect: true})

    },
    OpenVacationBanInfo($event, ban) {
      let view = this;
      let from = view.$helpers.getMomentFromStringTZ(ban.from).format("DD.MM.YYYY HH:mm");
      let to = view.$helpers.getMomentFromStringTZ(ban.to).format("DD.MM.YYYY HH:mm");

      let spotLabel = '';
      if (ban.spotId === null) {
        spotLabel = this.$t('pref.main.allSpots');
      } else {
        Object.values(this.spotMap).forEach(spot => {
          if (spot.id === ban.spotId) {
            spotLabel = spot.name;
          }
        });
      }

      this.$helpers.OpenPopup({
        elRelative: $event.currentTarget,
        type: 'datafill',
        componentState: {
          entries: [
            {label: this.$t('roster.main.title'), key: 'description', disabled: true, hidden: false, type: 'text', value: ban.description},
            {label: this.$t('roster.main.unit'), key: 'spotId', disabled: true, hidden: false, type: 'text', value: spotLabel},
            {label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'text', disabled: true, value: from},
            {label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'text', disabled: true, value: to},
            {label: this.$tc('global.general.type'), key: 'type', hidden: false, type: 'text', disabled: true, value: ban.type == 1 ? this.$t('pref.main.block') : this.$t('pref.main.preferenceBan')},
            {label: this.$t('global.general.active'), key: 'active', disabled: true, hidden: false, type: 'bool', value: ban.active}
          ],
          selectCallback: function (item) {

          }
        },
        header: this.$t('pref.main.absenceBlockInfo'),
        expanded: true,
        centered: true,
      });
    },
    GetWidthFirstTitle() {
      let width = 100;
      if (this.displayedTimeframeSelected.divisions === 36) width = 66.6666;
      if (this.displayedTimeframeSelected.divisions === 48) width = 50;
      width += '%';
      return width;
    },
    GetTimeMarkWidth(index) {

      let timeFrame = this.displayedTimeframeSelected;
      if (timeFrame.label === 'Y') {
        let lengthYear = timeFrame.length;
        let lengthMonth = timeFrame.timeStart.clone().month(index).daysInMonth() * 24 * 60 * 60 * 1000;
        let widthMonth = lengthYear / lengthMonth;
        return {width: ($(this.$el).find('.time-marks').width() / widthMonth) + 'px'};
      }
      return {width: ($(this.$el).find('.time-marks').width() / parseInt(timeFrame.divisions)) + 'px'};
    },

    SelectTimeFrame($event, timeFrame) {
      let view = this;
      if(!view.dragging){
        let labelOptions = [];
        labelOptions.push({
          text: this.$t('shift.plan.info'), type: 'block', click: () => {
            view.OpenVacationBanInfo($event, timeFrame.vacationban);
          }
        });
        labelOptions.push({
          text: this.$t('global.ui.edit'), type: 'block', click: () => {
            view.OpenEditVacationBanModal($event, timeFrame.vacationban);
          }
        });
        labelOptions.push({
          text: this.$t('global.ui.delete'), type: 'block', click: () => {
            view.OpenDeleteVacationBanModal($event, timeFrame.vacationban);
          }
        });

        this.$helpers.OpenListLabel(labelOptions, {allowOverflow: true});
      }

    },
    getVacationBanTooltip(timeFrame){
      let view = this;
      return () => {
        let vacban = view.vacationBanMap[timeFrame.vacationban.id];
        return (vacban.type == 1 ? this.$t('pref.main.vacationBan') : this.$t('pref.main.preferenceBan')) + " "
            + view.$helpers.getMomentFromStringTZ(vacban.from).format("DD.MM.YYYY HH:mm") + "&nbsp- "
            + view.$helpers.getMomentFromStringTZ(vacban.to).format("DD.MM.YYYY HH:mm");
      }
    },
    CheckLabelLength($event){
      let el = $event.currentTarget;
      let box = el.getBoundingClientRect();
      let boxlabel = el.querySelector('.label').getBoundingClientRect();
      if(boxlabel.width > box.width) el.classList.add('show-under');
      else el.classList.remove('show-under');
    },

    StartDragTimeFrame($event, timeFrame, isStart){
      var view = this;
      this.dragging = true;
      this.draggingStart = isStart;
      this.draggingTimeFrame = timeFrame;
      this.draggingTimeInit = isStart ? timeFrame.fromDate.clone() : timeFrame.toDate.clone();
      this.draggingStartPos = {x: window.mouse.x, y: window.mouse.y};
      this.draggingHandle = $event.currentTarget;
      this.DragWatch();
    },
    DragWatch(){
      var view = this;
      var time = view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
      var timeLimit = !view.draggingStart ? view.draggingTimeFrame.fromDate : view.draggingTimeFrame.toDate;
      if($(this.$el).find('.drag-info').length > 0) $(this.$el).find('.drag-info').css({left: (window.mouse.x - ($(this.$el).find('.drag-info')[0].getBoundingClientRect().width * .5)) + 'px', top: (this.draggingHandle.getBoundingClientRect().top - 45)+ 'px'});
      var totalWidth = $(this.$el).find('.grid').width() - 225;
      var timePixelRatio = totalWidth / this.timeFrameLength;

      var delta = window.mouse.x - this.draggingStartPos.x;
      var deltaTime = this.draggingTimeInit.clone().add(delta / timePixelRatio, 'milliseconds');
      time.year(deltaTime.year());
      time.month(deltaTime.month());
      time.date(deltaTime.date());
      if(view.draggingTimeFrame.toDate._d.getTime() - view.draggingTimeFrame.fromDate._d.getTime() < (24 * 60 * 60 * 1000)) {
        if(time === view.draggingTimeFrame.fromDate) view.$helpers.SetMomentTimeFromMoment(time, timeLimit).add(1, 'days');
        else view.$helpers.SetMomentTimeFromMoment(time, timeLimit).add(1, 'days');
      }

      if(time === view.draggingTimeFrame.fromDate) {
        view.draggingTime = {fromDate: time.clone(), toDate: view.draggingTimeFrame.toDate};
        view.$helpers.SetMomentTimeFromMoment(view.draggingTimeFrame.fromDate, time);
      } else {
        view.draggingTime = {fromDate: view.draggingTimeFrame.fromDate, toDate: time.clone()};
        view.$helpers.SetMomentTimeFromMoment(view.draggingTimeFrame.toDate, time);
      }

      time.seconds(0);
      time.milliseconds(0);

      view.$forceUpdate();
      requestAnimationFrame(function(){
        if(window.mouse.click) view.DragWatch();
        else {
          view.dragging = false;
          requestAnimationFrame(function(){
            view.EndDragTimeFrame();
          });
        }
      });
    },
    EndDragTimeFrame(){
      let view = this;
      let timeframe = this.draggingTimeFrame;
      this.editVacationBanAfterDrag(this.draggingTimeFrame.vacationban, this.draggingTime.fromDate, this.draggingTime.toDate);
    },

    GetTimeFrameStyles(timeFrame) {

      let totalWidth = $(this.$el).find('.time-marks').width();
      let timePixelRatio = totalWidth / this.timeFrameLength;


      let background = timeFrame.active ? (timeFrame.type == 1 ? '#e51c50' : '#e5c420') : '';
      let styles = {
        width: (this.TimeDiff(timeFrame.fromDate, timeFrame.toDate) * timePixelRatio) + 'px',
        'min-width': this.displayedTimeframeSelected.label !== 'D' ? ((8 * 60 * 60 * 1000) * timePixelRatio) + 'px' : '',
        left: (this.TimeDiff(this.timeFrameStart, timeFrame.fromDate) * timePixelRatio) + 'px',
        background: background,
      };
      return styles;
    },
    GetGroupStyles(group) {

      let background = group.color;
      let styles = {
        background: background
      };
      return styles;
    },
    TimeDiff(a, b) {
      return b._d.getTime() - a._d.getTime();
    },
    SelectToday() {
      let date = this.$helpers.getMomentTZ();
      this.onDatePicked(date, 'M', 36);

    },
    SelectMonth(month) {
      this.onDatePicked(month.moment, 'M', 36);
    },
    SelectPreviousDate() {
      if (this.displayedTimeframeSelected.label === 'M') {
        let date = this.timeFrameStart.clone().add(-1, 'month');
        this.onDatePicked(date, 'M', 24);
      } else if (this.displayedTimeframeSelected.label === 'Y') {
        let date = this.timeFrameStart.clone().add(-1, 'year');
        this.onDatePicked(date, 'Y', 24);
      } else {
        let date = this.timeFrameStart.clone().add(-1, 'day');
        this.onDatePicked(date, 'D', this.displayedTimeframeSelected.divisions);
      }


    },
    SelectNextDate() {
      if (this.displayedTimeframeSelected.label === 'M') {
        let date = this.timeFrameStart.clone().add(1, 'month');
        this.onDatePicked(date, 'M', 24);
      } else if (this.displayedTimeframeSelected.label === 'Y') {
        let date = this.timeFrameStart.clone().add(1, 'year');
        this.onDatePicked(date, 'Y', 24);
      } else {
        let date = this.timeFrameStart.clone().add(1, 'day');
        this.onDatePicked(date, 'D', this.displayedTimeframeSelected.divisions);
      }

    },
    toggleDatePicker($event) {
      let view = this;
      let date = this.dateSelectionStart;

      this.$helpers.OpenDatepickerPopup(
          {
            viewsEnabled: ['Y'],
            selectedTab: this.displayedTimeframeSelected.label,
            date: date,
            hourlyEnabled: true,
            hourlySelection: [12, 24, 36],
            hourlySelected: view.hourlySelection
          },
          {
            OnDateSelect: (date) => {

            },
            OnMonthSelect: (date) => {
              view.onDatePicked(date, 'M');
            },
            OnDaySelect: (date, hours) => {
              view.onDatePicked(date, 'D', hours);
            },
            OnYearSelect: (date) => {
              view.onDatePicked(date, 'Y');
            }
          }, {elRelative: $event.currentTarget});
    },
    onDatePicked(date, timeFrameType, hours = 24) {
      this.hourlySelection = hours;
      let before = this.timeFrameStart.clone();
      if (timeFrameType === 'Y') {
        this.timeFrameStart = date.clone().startOf('year');
      } else if (timeFrameType === 'M') {
        this.timeFrameStart = date.clone().startOf('month');
      } else {
        this.timeFrameStart = date.clone().startOf('day');
      }

      if (before.year() != this.timeFrameStart.year()) {
        //month / year change => trigger reload
        let rosterDate = this.timeFrameStart.clone().startOf('month');
        this.setDateSelection(rosterDate, true);
      } else {
        this.setDateSelection(this.timeFrameStart, !this.rosterFromTo);
      }
      this.setDateSelection(this.timeFrameStart, false);
      let displayTimeFrame;
      if (timeFrameType === 'Y') {
        displayTimeFrame = {
          label: 'Y',
          length: this.$helpers.getMomentTZ().month(11).date(31).dayOfYear() * 24 * 60 * 60 * 1000,
          divisions: 12,
          timeStart: this.timeFrameStart.clone().month(0).date(1)
        };
      } else if (timeFrameType === 'M') {
        displayTimeFrame = {
          label: 'M',
          length: this.timeFrameStart.daysInMonth() * 24 * 60 * 60 * 1000,
          divisions: this.timeFrameStart.daysInMonth(),
          timeStart: this.timeFrameStart.clone().date(1)
        };
      } else {
        displayTimeFrame = {
          label: 'D',
          length: hours * 60 * 60 * 1000,
          divisions: hours,
          timeStart: this.timeFrameStart.clone()
        };
      }
      this.displayedTimeframes = [displayTimeFrame];
      this.timeFrameLength = displayTimeFrame.length;
      this.timeFrameEnd = this.timeFrameStart.clone().add(this.timeFrameLength, 'milliseconds');
      this.displayedTimeframeSelected = displayTimeFrame;


      this.$forceUpdate();

    },
    setDateSelection(date, calculateRosterFromTo) {
      let fixedDate = this.$helpers.getMomentTZ().year(date.year()).month(date.month()).date(date.date()).startOf('day');
      this.dateSelectionStart = fixedDate;

      this.currentDate = date.date();
      this.currentMonth = date.month();
      this.currentYear = date.year();
      //if(this.displayedTimeframeSelected.label === 'D') this.displayedTimeframeSelected.timeStart = date.clone();

      if (calculateRosterFromTo) {
        //update vuex store with calculated from to => triggers reload of data via refresh

        let rosterFromTo = this.$helpers.CalculateRosterFromTo(date);
        this.$store.commit('setRosterFromTo', {rosterFromTo: rosterFromTo});
      } else {
        //dont update vuex from to, only update client side view
      }
    },

    OpenCreateVacationBanModal($event) {
      let view = this;
      let from = this.$helpers.getMomentTZ().startOf('day');
      let to = from.clone().add(1, 'days');
      let spotitems = this.spotDropDownItems;
      let typeItems = [{label: this.$t('pref.main.vacationBan'), value: 1, selected: true}, {label: this.$t('pref.main.preferenceBan'), value: 2}]
      view.$helpers.OpenPopup({
        elRelative: $event.currentTarget,
        type: 'datafill',
        componentState: {
          entries: [
            {label: this.$t('roster.main.title'), key: 'description', hidden: false, type: 'text', value: this.$t('roster.main.title'), flexGroup: false},
            {
              label: this.$t('roster.main.unit'),
              key: 'spotId',
              hidden: false,
              type: 'dropdownsearch',
              value: null,
              selectMultiple: false,
              flexGroup: false,
              dropdownSearchState: {
                toggled: false,
                displayedItems: [],
                input: '',
                items: spotitems,
                selectMultiple: false,
                selectedItems: [],
                selectedItem: {},
                onceSelected: function ($event, item, searchbar) {
                },
                styleLight: true,
                placeholder: this.$t('store.structure.selectBusinessunit'),
              },
              styles: {width: '442px'}
            },
            {
              label: this.$tc('global.general.type'),
              key: 'type',
              hidden: false,
              type: 'dropdownsearch',
              value: 1,
              selectMultiple: false,
              flexGroup: false,
              dropdownSearchState: {
                toggled: false,
                displayedItems: [],
                input: '',
                items: typeItems,
                selectFirst: true,
                selectMultiple: false,
                selectedItems: [typeItems[0]],
                selectedItem: typeItems[0],
                onceSelected: function ($event, item, searchbar) {
                },
                styleLight: true,
                placeholder: this.$t('global.ui.selectType'),
              },
              styles: {width: '442px'}
            },
            {label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'datetimeframe', value: from},
            {label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'datetimeframe', value: to,
                computed: (datafill, lastVal, entryBeforeUpdate) => {

                  let bfrom = datafill.entries.find(i => i.key == 'from').value;
                  let bto = datafill.entries.find(i => i.key == 'to').value;
                  if(bto <= bfrom){
                      let newDate = bfrom.clone().add(1, 'days');
                      entryBeforeUpdate.value = newDate;
                      entryBeforeUpdate.date = newDate.date();
                      entryBeforeUpdate.month = newDate.month()+1;
                      entryBeforeUpdate.year = newDate.year();

                  }
                    return entryBeforeUpdate;
                  }
            },
            {label: this.$t('global.general.active'), key: 'active', hidden: false, type: 'bool', value: true}
          ],
          errorCheck: [
            (entries) => {
              if (entries["from"] >= entries["to"]) {
                return {
                  key: 'to',
                  type: 'error',
                  label: this.$t('store.settings.date'),
                  text: this.$t('pref.main.fromBeforeTo')
                }
              } else {
                return null
              }
            },
            (entries) => {
              if (entries["description"] == null || entries["description"].length == 0) {
                return {
                  key: 'description',
                  type: 'error',
                  label: this.$t('roster.main.title'),
                  text: this.$t('pref.main.pleaseEnterTitle')
                }
              } else {
                return null
              }
            },
            (entries) => {
              if (entries["type"] == null) {
                return {
                  key: 'type',
                  type: 'error',
                  label: this.$tc('global.general.type'),
                  text: this.$t('workBalance.extraPay.selectTypeMin')
                }
              } else {
                return null
              }
            }
          ],
          selectCallback: function (item) {
            if (item.from < item.to) {
              view.createVacationBan(item);
            } else {
              view.$helpers.error(view.$t('global.ui.creationFailed'), view.$t('pages.comp.invalidDate'));
            }
          }
        },
        header: this.$t('pref.main.newVacationBan'),
        centered: true,
        expanded: true,
      });
    },
    OpenEditVacationBanModal($event, item) {
      let view = this;

      this.$helpers.OpenPopup({
        elRelative: $event.currentTarget,
        type: 'datafill',
        componentState: {
          entries: [
            {
              label: this.$t('roster.main.title'),
              key: 'description',
              hidden: false,
              type: 'text',
              value: item.description,
              flexGroup: false
            },
            {label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'datetimeframe', value: item.from},
            {label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'datetimeframe', value: item.to},
            {label: this.$t('global.general.active'), key: 'active', hidden: false, type: 'bool', value: item.active},
            // hidden items
            {label: this.$t('roster.main.unit'), key: 'spotId', hidden: true, value: item.spotId},
            {label: this.$tc('global.general.type'), key: 'type', hidden: true, value: item.type},
            {label: "Id", key: 'id', hidden: true, value: item.id}
          ],
          errorCheck: [
            (entries) => {
              if (entries["from"] >= entries["to"]) {
                return {
                  key: 'to',
                  type: 'error',
                  label: this.$t('store.settings.date'),
                  text: this.$t('pref.main.fromBeforeTo')
                }
              } else {
                return null
              }
            },(entries) => {
              if (entries["description"] == null || entries["description"].length == 0) {
                return {
                  key: 'description',
                  type: 'error',
                  label: this.$t('roster.main.title'),
                  text: this.$t('pref.main.pleaseEnterTitle')
                }
              } else {
                return null
              }
            }
          ],
          selectCallback: function (item) {

            view.editVacationBan(item);
          },

        },
        header: this.$t('global.ui.editX', [item.type == 1 ? this.$t('pref.main.vacationBan') : this.$t('pref.main.preferenceBan')]),
        centered: true,
        expanded: true,
      });
    },
    OpenDeleteVacationBanModal($event, data) {
      let view = this;
      view.$helpers.OpenAlert({
        header: this.$t('global.ui.deleteX', [this.$t('pref.main.block')]),
        description: this.$t('pref.main.deleteBlockQuery', [data.description]),
        callbackAccept: (alert) => {
          alert.hidden = true;
          view.deleteVacationBan(data);
        }
      });
    },

    loadVacationBans: function () {
      let view = this;
      let url = '/api/sec/vacationban';
      let params = {
        storeId: this.$store.state.storeId,
        from: this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).startOf('year').format(),
        to: this.$helpers.getMomentTZ().year(this.$store.state.rosterFromTo.year).startOf('year').add(1, 'year').format()
      };

      return this.axios({
        method: 'get',
        params: params,
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url
      }).then(response => {
        view.updateVacationBans(response.data)
      }).catch(function (error) {
        console.log(error)
      });
    },
    editVacationBan: function (item) {
      let view = this;
      let url = '/api/sec/vacationban';
      let params = {
        storeId: this.storeId,
      }

      let payload = {
        id: item.id,
        description: item.description,
        spotId: item.spotId,
        from: item.from,
        to: item.to,
        active: item.active,
        type: item.type,
        updateFields: ["description", "spotId", "active", "from", "to", "type"]
      }

      this.axios({
        method: 'put',
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url,
        params: params,
        data: payload
      }).then(response => {
        view.$set(view.vacationBanMap, payload.id, payload);
        view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.ui.editedX', [view.$t('pref.main.block')]));
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.plan.editProjectError'));
        console.log(error)
      })

    },
    editVacationBanAfterDrag(vacationban, fromDate, toDate){
      let view = this;
      let url = '/api/sec/vacationban';
      let params = {
        storeId: this.storeId,
      }

      let payload = {
        id: vacationban.id,
        spotId: vacationban.spotId,
        active: vacationban.active,
        description: vacationban.description,
        updateFields: []
      };

      let cfrom = this.$helpers.convertDateString(fromDate);
      payload.from = cfrom;
      payload.updateFields.push("from");
      let cto = this.$helpers.convertDateString(toDate);
      payload.to = cto;
      payload.updateFields.push("to");

      this.axios({
        method: 'put',
        headers: {
          'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url,
        params: params,
        data: payload
      }).then(response => {

        view.$set(view.vacationBanMap, payload.id, payload);
        view.draggingTimeFrame = null;
        view.draggingTime = null;
        view.$helpers.success(view.$t('global.notifications.updateMessage'), view.$t('global.ui.editedX', [view.$t('pref.main.block')]));
      }).catch(function (error) {
          view.error=true;
          view.draggingTimeFrame = null;
          view.$helpers.error(view.$t('global.notifications.updateFailed'), view.$t('global.ui.editedErrorX', [view.$t('pref.main.block')]));
        console.log(error)
      })

    },
    deleteVacationBan: function (item) {
      let view = this;
      let url = '/api/sec/vacationban';
      let params = {
        id: item.id,
        storeId: this.storeId,
      }

      this.axios({
        method: 'delete',
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        params: params,
        url: url
      }).then(response => {
        view.$delete(view.vacationBanMap, item.id);
        view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.ui.deletedX', [view.$t('pref.main.block')]));
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.deletedErrorX', [view.$t('pref.main.block')]));
        console.log(error)
      })

    },

    createVacationBan: function (item) {
      let view = this;
      let url = '/api/sec/vacationban';
      let params = {
        storeId: this.storeId,
      }

      let payload = {
        description: item.description,
        active: item.active,
        spotId: item.spotId,
        from: item.from,
        to: item.to,
        type: item.type,
      }


      this.axios({
        method: 'post',
        headers: {
          'AUTHORIZATION': "bearer " + this.$store.state.jwt
        },
        url: url,
        params: params,
        data: payload
      }).then(response => {
        view.$set(view.vacationBanMap, response.data.data.id, response.data.data);
        view.$helpers.success(view.$t('global.notifications.success'), view.$t('global.ui.createdX', [view.$t('pref.main.block')]));
      }).catch(function (error) {
        view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.ui.createdErrorX', [view.$t('pref.main.block')]));
        console.log(error)
      })

    },
    updateVacationBans: function (data) {
      let tMap = {};
      for (let i = 0; i < data.length; i++) {
        tMap[data[i].id] = data[i];

      }
      this.vacationBanMap = tMap;
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.vacationban-view {
  position: relative;
}

.vacationban-view > .header {
  background: var(--contrast-1);
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 60px;
  text-align: center;
  z-index: 2;

}

.vacationban-view > .header > * {
  display: inline-flex;
  align-items: center;
}

.vacationban-view > .header {
  justify-content: center;

}

.grid {
  padding-top: 40px;
  text-align: center;
  position: relative;
  height: 100%;
}

.grid > .header {
  position: fixed;
  top: 145px;
  left: 6px;
  width: 100%;
  z-index: 20;
  padding-left: 10px;
}

.group {
  margin-bottom: 10px;
}

.group > .header {
  width: 255px;
  height: 19px;
  background: #6d8d23;
  border-top-left-radius: 50px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 50px;
  position: relative;
  z-index: 2;
  margin-left: 5px;
}

.group > .header .label {
  color: white;
  font-size: 13px;
  padding-left: 20px;
}

.group.group-null > .header .label {
  padding-left: 10px;
}


.group > .header .fa-stack {
  position: absolute;
  right: -10px;
  transform: scale(0.55);
  top: -4px;
  margin: 0;
  cursor: pointer;
}


.group > .header .fa-stack > * {
  pointer-events: none;
}

.group > .header .fa-stack.add {
  right: 6px;
}

.group > .header .fa-stack *:not(.fa-circle) {
  color: #6d8d23;
}

.group > .header .fa-stack .fa-circle {
  color: #e5e5e5;
}

.group > .header .fa-stack:hover .fa-circle {
  color: #707070 !important;
}

.group > .header .fa-stack:hover *:not(.fa-circle):not(.fa-arrows-alt) {
  color: #e5e5e5 !important;
}

.group > .header .fa-stack.drag {
  right: initial;
  left: -10px;
}

.group > .header .fa-stack.drag .fa-arrows-alt {
  line-height: 130%;
  font-size: 20px;
  color: white;
}

.group > .header .fa-stack.drag .fa-circle {
  display: none;
}


.vacationban .fa-stack {

  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
}

.vacationban:hover .fa-stack.detail {
  opacity: 1;
}

.vacationban .fa-stack.detail {
  opacity: 1;
  cursor: pointer;
  font-size: 25px;
  width: 25px;
  height: 25px;
  right: 5px;
}

.vacationban .fa-stack.detail:hover .fa-circle {
  color: #6d8d23 !important;
}

.vacationban .fa-stack.detail:hover .fa-map {
  color: #404040 !important;
}

.vacationban .fa-stack > .fas:not(.fa-circle) {
  transform: scale(.55);
}


.row {
  position: relative;
  width: calc(100% - 215px);
  padding: 5px;
  margin-left: 260px;
  height: 35px;
}

.grid .vacationban {
  position: absolute;
  top: 0;
  left: -245px;
  height: 36px;
  margin-bottom: 5px;
  padding-left: 45px;
  width: 245px;
  box-shadow: inset 0px -2px 0 -1px var(--contrast-1);
  z-index: 12;
  display: flex;
  align-items: center;
}

.vacationban .name {
  font-size: 13px;
  color: var(--contrast-5);
  text-align: left;
  height: 20px;
  white-space: nowrap;
  font-weight: 800;
  margin-top: 0px;
  margin-left: 0px;
  font-family: DistrictProBold;
  max-width: 100%;
  overflow: hidden;
}

.vacationban .name.shadow {
  height: 15px;
  white-space: nowrap;
  width: 30px;
  box-shadow: inset -30px 0 7px -7px var(--bg) !important;
  position: absolute;
  right: 0;
  top: 0;
}

.row:hover .vacationban .name.shadow {
  box-shadow: inset -30px 0 7px -7px var(--contrast-2) !important;
}

.vacationban .entitled .label {
  float: left;
  font-size: 12px;
  color: var(--contrast-5);
}

.time-marks {
  pointer-events: none;
  position: fixed;
  left: 260px;
  top: 200px;
  width: calc(100% - 278px);
  height: 100%;
  z-index: 10;
  padding: 0;
  white-space: nowrap;
}

.time-marks .label {
  position: absolute;
  top: -20px;
  left: -15px;
  width: 30px;
  text-align: center;
}


.time-marks.labels {
  z-index: 13;
}

.time-marks .mark {
  text-align: center;
  position: relative;
  width: calc(100% / 24);
  height: 100%;
  display: inline-block;
  box-shadow: inset 2px 0px 0 -1px var(--contrast-1);
  background: none;
}


.time-marks .mark.day-split {
  box-shadow: inset 3px 0px 0 -1px var(--contrast-4);
}

.time-marks.labels .mark {
  z-index: 13;
  height: 20px;;
}

.timeframe {
  position: absolute;
  height: calc(100% - 10px);
  background: #cccccc;
  z-index: 11;
  /*border-radius: 5px; */
  cursor: pointer;
  min-width: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.timeframe:hover {
  overflow: visible;
}

.timeframe .label {
  color: white;
  white-space: nowrap;
  position: absolute;
  left: 5px;
  right: 5px;
  margin: auto;
  text-align: center;
  pointer-events: none;
  width: auto;
  overflow: hidden;
}


.timeframe .shadow {
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
  box-shadow: inherit !important;
  border-radius: 5px;
  z-index: -2;
}

.timeframe.show-under:hover .label {
  left: -1000px;
  right: -1000px;
  bottom: -25px;
  background: inherit;
  padding: 1px 5px;
  z-index: 10;
  width: fit-content;
  display: inline-block;
  border-radius: 5px;
}

.grid .backdrop {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 260px;
  background: var(--bg);
  /*-webkit-box-shadow: 0 0 30px  var(--bg);
  box-shadow: 0 0 15px 10px  var(--bg);*/
  z-index: 2;
  pointer-events: none;
}

.scrollbar-container {
  width: 100%;
  overflow-x: hidden;
  padding-top: 37px;
}

.row .bottom-line, .row .top-line {
  box-shadow: inset 0px 2px 0 -1px var(--contrast-1);
  height: 1px;
  position: absolute;
  bottom: 0px;
  width: calc(100% + 245px);
  left: -245px;
}

.row .top-line {
  bottom: initial;
  top: 0px;
  display: none;
}

.row:nth-child(4) .top-line {
  display: initial;
}

.group.sub-spot > .header {
  width: 235px;
  margin-left: 25px;
}

.group.sub-spot .vacationban {
  width: 225px;
  left: -225px;
}

.filter.arrow .fas {
  transform: none;
  align-self: center;
}

.time-marks.monthly .label {
  position: absolute;
  display: block;
  top: -14px;
  left: 0;
  right: 0;
  text-align: center;
  width: 100%;
  bottom: initial;
  height: 34px;
  line-height: 35px;
  cursor: pointer;
}

.day-container {
  height: 80px;
  width: calc(100% - 278px);
  white-space: nowrap;
  position: fixed;
  left: 260px;
  top: calc((2 * var(--header-height)) + var(--tab-menu-height) + 21px); /* 14px is the space needed to fit the weather and filter button */
  z-index: 12;
  background: var(--bg);
  overflow: hidden;
}

.day-container .day {
  transition: .2s;
  transform: scale(1);
  position: relative;
  opacity: 1 !important;
  padding-bottom: 0;
  height: 75px;
  width: 40px;
  margin: 0;
  cursor: pointer !important;
  top: 11px;
  z-index: 10;
  display: inline-block;
  box-shadow: inset 2px 0px 0 -1px #d5d5d5, inset 0px 0px 0 -1px #d5d5d5;
  border-radius: 0;
}

.day-container .day .name {
  position: absolute;
  height: 50%;
  width: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  top: -10px;
  margin: auto;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: var(--contrast-4);
  border-radius: 0 !important;
  padding-top: 0 !important;
  background: none !important;
  cursor: pointer;
}

.day-container .day .date {

  position: absolute;
  height: 50%;
  width: 100%;
  left: 0;
  bottom: -20px;
  right: 0;
  top: 0;
  margin: auto;
  text-align: center;
  font-size: 10px;
  padding-top: 0 !important;
  border-radius: 0 !important;
  background: none !important;
  color: var(--contrast-4);
  cursor: pointer;
}

.day-container-selected .day {

  position: fixed;
  left: 0px;
  margin: 0;
  margin-top: -5px;
  z-index: 10000 !important;
  background: var(--bg);
  border-radius: 0;
  width: 90px;
  height: 40px;
  top: 121px;
  cursor: pointer;
}

.day-container-selected .day * {
  pointer-events: none;
}

.day-container-selected .day .shadow {
  position: absolute;
  height: 40px;
  width: 140px;
  -webkit-box-shadow: 0 0 1px 0 #808080;
  box-shadow: 0 0 1px 0 #808080;
  left: -50px;
  top: 0;
}

.day-container-selected .day .name {
  position: absolute;
  height: 50%;
  width: 100%;
  left: 0;
  bottom: 0;
  right: 0;
  top: -10px;
  margin: auto;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: var(--contrast-4);
  border-radius: 0 !important;
  padding-top: 0 !important;
  background: none !important;
  cursor: pointer;
}

.day-container-selected .day .date {
  position: absolute;
  height: 50%;
  width: 100%;
  left: 0;
  bottom: -20px;
  right: 0;
  top: 0;
  margin: auto;
  text-align: center;
  font-size: 10px;
  padding-top: 0 !important;
  border-radius: 0 !important;
  background: none !important;
  color: var(--contrast-4);
  cursor: pointer;
}

.header.date {
  display: inline-flex;
  align-items: center;
  position: absolute;
  z-index: 10;
  background: none;
  left: 0;
  right: initial;
  width: initial;
  padding: 0 20px;
}

.header.date .label {
  color: var(--contrast-4);
  font-family: DistrictProLight;
  font-weight: 200;
}

.day .day-text {
  transform: scale(1) translateY(6px);
  transition: .2s;
  height: 37px;
  cursor: pointer;
}

.day .day-text:hover {
  transform: scale(1.3) translateY(1px);
}

.day .day-text * {
  pointer-events: none;
}

.sub-header {
  display: flex;
  justify-content: left;
  width: calc(100vw - 277px);
  left: 260px;
  height: 72px;
  position: fixed;
  top: 144px;
  background: var(--bg);
  box-shadow: 0 2px 0 -1px #d5d5d5;
  z-index: 12;
}

.sub-header .title {
  position: relative;
  display: flex;
  justify-content: center;
  padding: 0;
  align-self: flex-start;
  top: 1px;
}

.sub-header .title .label {
  font-size: 16px;
  font-weight: 500;
}

.vacationban .background {
  position: absolute;
  top: 0;
  left: -100px;
  width: calc(100% + 100px);
  height: 100%;
  background: var(--bg);
  box-shadow: none;
  z-index: -1;
}

.vacationban .background.shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100% - 1px);
  background: var(--bg);
  z-index: -1;
  box-shadow: inset 0px -2px 0 -1px var(--contrast-1) !important;
}

.grid .row:hover .vacationban .background.shadow {
  background: var(--contrast-2);
  border-radius: 0;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  box-shadow: none !important;
}

.has-header > .has-header > .scrollbar-container {
  height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
  top: var(--header-height);
}

.header.date {
  display: inline-flex;
  justify-items: center;
  align-items: center;
  position: absolute;
  left: 20px;
}

.header.date .label {
  color: var(--contrast-4);
  font-family: DistrictProLight;
  font-weight: 200;
  margin-top: -3px;
}

.timeframe .handle{
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 15px;
  margin: auto;
  cursor: col-resize;
  color: #9f9f9f;
  text-align: center;
  transition: .2s;
  opacity: 0;
}

.timeframe .handle .inner{
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #9f9f9f;
  width: 2px;
  height: calc(100% - 10px);
  pointer-events: none;
}

.timeframe:hover .handle{
  opacity: 1;
}

.handle.start{
  left: -12px;
}

.handle.end{
  right: -12px;
}

</style>
